import dynamic from 'next/dynamic';

const PointsBalance = dynamic(
    async () => {
        const pkg = await import('@zooplus/loyalty-program-ui');
        return pkg.PointsBalance;
    },
    {
        ssr: false,
    },
);

export default PointsBalance;
